import {
    AttachmentLocalComputerFilePickerProps,
    IAttachmentLocalComputerFilePicker,
} from './components/AttachmentLocalComputerFilePicker';
import { AttachmentFileList } from 'owa-attachment-file-types';
import {
    createLazyComponent,
    LazyAction,
    LazyImport,
    LazyModule,
    LazyModuleType,
} from 'owa-bundling';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { ComponentClass } from 'react';
import {
    CreateAttachmentHandler,
    CreateAttachmentHandlerParams,
} from './types/CreateAttachmentHandler';
import {
    FileProviderItemViewState,
    FileSelectionFilter,
    FilePickerAction,
    SelectedFilesSource,
    lazyPreloadFilePicker,
    SizeLimitInKbToSuggestSharing,
    FilePickerUploadConfiguration,
    FilePickerConfiguration,
} from 'owa-filepicker';

export { ComponentClass };

/* This package is supposed to encapsulate all the attachment logic around owa-filepicker */
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AttachmentFilePicker", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded actions
export const lazyAttachmentFilePicker = new LazyAction(lazyModule, m => m.attachmentFilePicker);

// Delay loaded imports

// call this before your file picker is called to preload
export const lazyInitializeAttachmentFilePicker = lazyPreloadFilePicker;

// the following can be used to show the actions panel independent of the filepicker
export const lazyAttachmentActionsPanel = new LazyAction(lazyModule, m => m.attachmentActionsPanel);

// Delay loaded components
export const AttachmentLocalComputerFilePicker = createLazyComponent<
    AttachmentLocalComputerFilePickerProps,
    LazyModuleType<typeof lazyModule>,
    IAttachmentLocalComputerFilePicker
>(lazyModule, m => m.AttachmentLocalComputerFilePicker);

// delay loaded utility functions
export const lazyLogAttachOrShareDatapoint = new LazyImport(
    lazyModule,
    m => m.logAttachOrShareDatapoint
);

export {
    AttachmentDataProviderType,
    AttachmentFileList,
    AttachmentLocalComputerFilePickerProps,
    IAttachmentLocalComputerFilePicker,
    CreateAttachmentHandler,
    CreateAttachmentHandlerParams,
    FilePickerAction,
    FileProviderItemViewState,
    FileSelectionFilter,
    LazyImport,
    SelectedFilesSource,
    SizeLimitInKbToSuggestSharing,
    FilePickerUploadConfiguration,
    FilePickerConfiguration,
};
